import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const PropertyModelDetailAddedTaskAttemptFormSchema = z.object({
  type: z.literal(TaskType.PROPERTY_MODEL_DETAIL_ADDED),
  siteVisitProjectId: z.number().int().positive().optional(),
});

// The handler resolves the reviewed model server-side; optional so bare `{ type }` rows written by
// plain completion before this schema existed still parse on the DB-read path.
export const PropertyModelDetailAddedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.PROPERTY_MODEL_DETAIL_ADDED),
  propertyModelId: z.string().optional(),
  siteVisitProjectId: z.number().int().positive().optional(),
});
